import { useEffect } from "react";
import type { FC } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "../hooks/useAnalytics";

const AnalyticsTracker: FC = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Small delay to ensure the page has loaded and title is set
    const timer = setTimeout(() => {
      const fullPath = location.pathname + location.search;
      trackPageView(fullPath);
    }, 100);

    return () => clearTimeout(timer);
  }, [location, trackPageView]);

  // Track initial page load
  useEffect(() => {
    // Only track on mount, not on every location change
    const timer = setTimeout(() => {
      const fullPath = location.pathname + location.search;
      trackPageView(fullPath);
    }, 500); // Longer delay for initial load

    return () => clearTimeout(timer);
  }, []); // Empty dependency array for initial load only

  return null; // This component doesn't render anything
};

export default AnalyticsTracker;
